// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/store_coupon/v1/store_coupon.proto (package fingertip.creator.store_coupon.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { ApplyStoreCouponPublicRequest, ApplyStoreCouponPublicResponse, ApplyStoreCouponToAttendancePublicRequest, ApplyStoreCouponToAttendancePublicResponse, ApplyStoreCouponToBookingPublicRequest, ApplyStoreCouponToBookingPublicResponse, CreateStoreCouponRequest, CreateStoreCouponResponse, DeleteStoreCouponRequest, DeleteStoreCouponResponse, GetStoreCouponPublicRequest, GetStoreCouponPublicResponse, GetStoreCouponRequest, GetStoreCouponResponse, GetStoreCouponsRequest, GetStoreCouponsResponse, RemoveStoreCouponPublicRequest, RemoveStoreCouponPublicResponse, UpdateStoreCouponRequest, UpdateStoreCouponResponse } from "./store_coupon_pb.js";

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.ApplyStoreCouponPublic
 */
export const applyStoreCouponPublic = {
  localName: "applyStoreCouponPublic",
  name: "ApplyStoreCouponPublic",
  kind: MethodKind.Unary,
  I: ApplyStoreCouponPublicRequest,
  O: ApplyStoreCouponPublicResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.ApplyStoreCouponToBookingPublic
 */
export const applyStoreCouponToBookingPublic = {
  localName: "applyStoreCouponToBookingPublic",
  name: "ApplyStoreCouponToBookingPublic",
  kind: MethodKind.Unary,
  I: ApplyStoreCouponToBookingPublicRequest,
  O: ApplyStoreCouponToBookingPublicResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.ApplyStoreCouponToAttendancePublic
 */
export const applyStoreCouponToAttendancePublic = {
  localName: "applyStoreCouponToAttendancePublic",
  name: "ApplyStoreCouponToAttendancePublic",
  kind: MethodKind.Unary,
  I: ApplyStoreCouponToAttendancePublicRequest,
  O: ApplyStoreCouponToAttendancePublicResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.RemoveStoreCouponPublic
 */
export const removeStoreCouponPublic = {
  localName: "removeStoreCouponPublic",
  name: "RemoveStoreCouponPublic",
  kind: MethodKind.Unary,
  I: RemoveStoreCouponPublicRequest,
  O: RemoveStoreCouponPublicResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.GetStoreCoupon
 */
export const getStoreCoupon = {
  localName: "getStoreCoupon",
  name: "GetStoreCoupon",
  kind: MethodKind.Unary,
  I: GetStoreCouponRequest,
  O: GetStoreCouponResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.GetStoreCouponPublic
 */
export const getStoreCouponPublic = {
  localName: "getStoreCouponPublic",
  name: "GetStoreCouponPublic",
  kind: MethodKind.Unary,
  I: GetStoreCouponPublicRequest,
  O: GetStoreCouponPublicResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.GetStoreCoupons
 */
export const getStoreCoupons = {
  localName: "getStoreCoupons",
  name: "GetStoreCoupons",
  kind: MethodKind.Unary,
  I: GetStoreCouponsRequest,
  O: GetStoreCouponsResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.CreateStoreCoupon
 */
export const createStoreCoupon = {
  localName: "createStoreCoupon",
  name: "CreateStoreCoupon",
  kind: MethodKind.Unary,
  I: CreateStoreCouponRequest,
  O: CreateStoreCouponResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.UpdateStoreCoupon
 */
export const updateStoreCoupon = {
  localName: "updateStoreCoupon",
  name: "UpdateStoreCoupon",
  kind: MethodKind.Unary,
  I: UpdateStoreCouponRequest,
  O: UpdateStoreCouponResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_coupon.v1.StoreCouponService.DeleteStoreCoupon
 */
export const deleteStoreCoupon = {
  localName: "deleteStoreCoupon",
  name: "DeleteStoreCoupon",
  kind: MethodKind.Unary,
  I: DeleteStoreCouponRequest,
  O: DeleteStoreCouponResponse,
  service: {
    typeName: "fingertip.creator.store_coupon.v1.StoreCouponService"
  }
};
